"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormHelpText = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _Help = require("./Help.js");
var _IconExclamationCircleForText = require("./IconExclamationCircleForText.js");
var _Text = require("./Text.js");
var _layoutTheme = require("../../styles/layout-theme.js");
var _excluded = ["error", "maxChars", "children", "errorAriaLabel"];
/**
 * FormHelpText is placed after a form field and can display contextual information, character count or error notifications.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-formhelptext--docs) |
 * [Encore site](https://encore.spotify.net/web/components/form#help-text-1) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/FormHelpText) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=32403-15523&t=NcrXkYtzM5yslqPK-1)
 */
var FormHelpText = exports.FormHelpText = function FormHelpText(_ref) {
  var error = _ref.error,
    maxChars = _ref.maxChars,
    children = _ref.children,
    _ref$errorAriaLabel = _ref.errorAriaLabel,
    errorAriaLabel = _ref$errorAriaLabel === void 0 ? 'Error:' : _ref$errorAriaLabel,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Help.Help, Object.assign({
    $error: error,
    $maxChars: maxChars
  }, props, {
    className: (0, _classnames["default"])((0, _layoutTheme.textClass)('bodySmall'), props.className),
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.FormHelpText
  }), error && /*#__PURE__*/_react["default"].createElement(_IconExclamationCircleForText.IconExclamationCircleForText, {
    "aria-label": errorAriaLabel
  }), /*#__PURE__*/_react["default"].createElement(_Text.Text, null, children));
};